import React from "react";
import AddRoleComponent from "./addRoleComponent";
import Aside from "./aside";
import TopBar from "./topBar";

const AddRole = () => {
  return (
    <div className='main-wrapper'>
      <div className='content-wrapper'>
        <AddRoleComponent />
      </div>
    </div>
  );
};

export default AddRole;
